import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { DndProvider, Preview } from "react-dnd-multi-backend";
import { HTML5toTouch } from "rdndmb-html5-to-touch";
import { generatePreview } from "@nualang/nualang-ui-components/dist/Misc/DragAndDropPreview";
import "typeface-montserrat";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "animate.css/animate.min.css";
import "../styles/amplify.css";
import "../styles/app.css";
import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: 1000 * 60 * 5, // 5 minutes
    },
  },
});

export default function withRoot(Component) {
  return function WrapperComponent(props) {
    return (
      <QueryClientProvider client={queryClient} contextSharing={true}>
        {process.env.REACT_APP_PW_E2E ? null : (
          <ReactQueryDevtools buttonPosition="bottom-left" />
        )}
                      <DndProvider options={HTML5toTouch}>
                        <Component {...props} />
                        <Preview generator={generatePreview} />
                      </DndProvider>
      </QueryClientProvider>
    );
  };
}
